import { useQuery } from "@tanstack/react-query";
import { boronClient } from "../../api";
import { createError, HTTPErrors } from "../../errors";
import { paths } from "../../lib/api/v1";

const path =
  "/api/v1/sections/multi_section_batches/drill_learning_materials/{steak_material_code}";

type ResponseBody =
  paths[typeof path]["get"]["responses"]["200"]["content"]["application/json"];

export type DrillDetail = ResponseBody["drill"];

export const useDrillDetail = (materialCode: string) => {
  const { data, isLoading, error } = useQuery<ResponseBody, HTTPErrors>({
    queryKey: ["drillLearningMaterialDetail", materialCode],
    queryFn: async () => {
      const { response } = await boronClient.GET(path, {
        params: {
          path: {
            steak_material_code: materialCode,
          },
        },
      });

      if (response.ok) {
        return response.json();
      }

      throw await createError(response);
    },
    enabled: !!materialCode,
  });

  return {
    drill: data?.drill,
    isLoading,
    error,
  };
};
